import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id F528B8DF-1FE3-47C0-B406-70FAC5718CE1
 * name image-auto-adjust
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-auto-adjust.svg
 * tags
 * - Photography 
 */
export const ImageAutoAdjustIcon = createSvgIcon(<><path d="M19 10V19H5V5H14V3H5C3.92 3 3 3.9 3 5V19C3 20.1 3.92 21 5 21H19C20.12 21 21 20.1 21 19V10H19M17 10L17.94 7.94L20 7L17.94 6.06L17 4L16.06 6.06L14 7L16.06 7.94L17 10M13.25 10.75L12 8L10.75 10.75L8 12L10.75 13.25L12 16L13.25 13.25L16 12L13.25 10.75Z" /></>, 'ImageAutoAdjustIcon');
export default ImageAutoAdjustIcon